module.exports = __webpack_public_path__ + "img/publicity-1.7a29b30f.png";